import * as Yup from "yup";

export const departmentSchema = Yup.object({
  department_name: Yup.string().required("Department Name is required"),
});
